import { useQuery } from '@tanstack/react-query';
import { getAll } from '../services/getAllService';

const emptyResponse = entities => {
  if (Array.isArray(entities))
    return entities.reduce((prev, curr) => {
      prev[curr] = [];
      return prev;
    }, {});
  return { [entities]: [] };
};

const getGetAllReq = async (entities, params) => {
  try {
    const { data } = await getAll(entities, params);
    return data || emptyResponse(entities);
  } catch (err) {
    console.error(err);
    throw err;
  }
};

export const useGetAll = (entities, params, enabled = true) => {
  const query = useQuery({
    queryKey: ['getAll', JSON.stringify(entities), JSON.stringify(params)],
    queryFn: () => getGetAllReq(entities, params),
    placeholderData: emptyResponse(entities),
    refetchOnWindowFocus: false,
    refetchOnMount: 'always',
    staleTime: 60 * 1000,
    enabled,
  });

  return {
    ...query,
    data: query.data || emptyResponse(entities),
  };
};
